import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfigSelector from '../components/ConfigSelector';
import ConfigForm from '../components/ConfigForm/ConfigForm';
import DashboardLayout from '../components/DashboardLayout';

const Dashboard = () => {
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [configData, setConfigData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const handleConfigSelect = useCallback(async (configId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`/api/config/${configId}`, {
        headers: {
          'Authorization': `Bearer ${token}` // Include the token
        }
      });
      
      if (response.status === 401 || response.status === 403) {
        navigate('/login');
        return;
      }

      const data = await response.json();
      setConfigData({
        config_json: data.config_json,
        service_disabled: !data.service_enabled
      });
      setSelectedConfig(configId);
    } catch (error) {
      console.error('Error loading config:', error);
    }
  }, [navigate]);

  const handleSave = async (updatedConfig) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('/api/save-config', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Include the token
         },
        body: JSON.stringify({
          id: selectedConfig,
          config: updatedConfig
        })
      });

      if (response.status === 401) {
        navigate('/login');
        return;
      }

      alert('Configuration saved successfully!');
    } catch (error) {
      console.error('Error saving config:', error);
    }
  };

  return (
    <DashboardLayout>
      <div className="dashboard">
        <ConfigSelector onSelect={handleConfigSelect} />
        {configData && (
          <ConfigForm config={configData} onSave={handleSave} />
        )}
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
